<div class="home-container container mt-4">
   
<mat-tab-group (selectedTabChange)="onTabChange($event)">
  <!-- Tab Check-In -->
  <mat-tab label="Check-In - {{ getNowString(true) }}">
    <app-checkin-tab
      [dataSource]="dataSourceCheckIn"
      [totalCount]="totalCountCheckIn"
      [pageSize]="pageSizeCheckIn"
      [pageIndex]="currentPageCheckIn"
      [isLoading]="isLoadingCheckIn"
      [errorClassFn]="getErrorCheckInClass"
      [canCheckInFn]="canCheckIn.bind(this)"
      [canCheckOutFn]="canCheckOut.bind(this)"
      [canCancelFn]="canCancel.bind(this)"
      [canEditFn]="canEdit.bind(this)"
      [canRegisterPaymentFn]="canRegisterPayment.bind(this)"
      (pageChange)="onPageChange($event,'checkIn')"
      (actionClick)="onAction($event,'checkIn')">
    </app-checkin-tab>
  </mat-tab>

  <!-- Tab Check-Out -->
  <mat-tab label="Check-Out - {{ getNowString(true) }}">
    <app-checkout-tab
      [dataSource]="dataSourceCheckOut"
      [totalCount]="totalCountCheckOut"
      [pageSize]="pageSizeCheckOut"
      [pageIndex]="currentPageCheckOut"
      [isLoading]="isLoadingCheckOut"
      [errorClassFn]="getErrorCheckOutClass"
      [canCheckInFn]="canCheckIn.bind(this)"
      [canCheckOutFn]="canCheckOut.bind(this)"
      [canCancelFn]="canCancel.bind(this)"
      [canEditFn]="canEdit.bind(this)"
      [canRegisterPaymentFn]="canRegisterPayment.bind(this)"
      (pageChange)="onPageChange($event,'checkOut')"
      (actionClick)="onAction($event,'checkOut')">
    </app-checkout-tab>
  </mat-tab>

  <!-- Tab En curso -->
  <mat-tab label="En curso">
    <app-inprogress-tab
      [dataSource]="dataSourceInProgress"
      [totalCount]="totalCountInProgress"
      [pageSize]="pageSizeInProgress"
      [pageIndex]="currentPageInProgress"
      [isLoading]="isLoadingInProgress"
      [errorClassFn]="getErrorCheckOutClass"
      [canCheckInFn]="canCheckIn.bind(this)"
      [canCheckOutFn]="canCheckOut.bind(this)"
      [canCancelFn]="canCancel.bind(this)"
      [canEditFn]="canEdit.bind(this)"
      [canRegisterPaymentFn]="canRegisterPayment.bind(this)"
      (pageChange)="onPageChange($event,'inProgress')"
      (actionClick)="onAction($event,'inProgress')">
    </app-inprogress-tab>
  </mat-tab>
</mat-tab-group>

</div>